export const LanguageCode = [
  { "code": "aa", "name": "Afar" },
  { "code": "ab", "name": "Abkhazian" },
  { "code": "ae", "name": "Avestan" },
  { "code": "af", "name": "Afrikaans" },
  { "code": "ak", "name": "Akan" },
  { "code": "am", "name": "Amharic" },
  { "code": "an", "name": "Aragonese" },
  { "code": "ar", "name": "Arabic" },
  { "code": "as", "name": "Assamese" },
  { "code": "av", "name": "Avaric" },
  { "code": "ay", "name": "Aymara" },
  { "code": "az", "name": "Azerbaijani" },
  { "code": "ba", "name": "Bashkir" },
  { "code": "be", "name": "Belarusian" },
  { "code": "bg", "name": "Bulgarian" },
  { "code": "bh", "name": "Bihari languages" },
  { "code": "bi", "name": "Bislama" },
  { "code": "bm", "name": "Bambara" },
  { "code": "bn", "name": "Bengali" },
  { "code": "bo", "name": "Tibetan" },
  { "code": "br", "name": "Breton" },
  { "code": "bs", "name": "Bosnian" },
  { "code": "ca", "name": "Catalan; Valencian" },
  { "code": "ce", "name": "Chechen" },
  { "code": "ch", "name": "Chamorro" },
  { "code": "co", "name": "Corsican" },
  { "code": "cr", "name": "Cree" },
  { "code": "cs", "name": "Czech" },
  {
    "code": "cu",
    "name": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"
  },
  { "code": "cv", "name": "Chuvash" },
  { "code": "cy", "name": "Welsh" },
  { "code": "da", "name": "Danish" },
  { "code": "de", "name": "German" },
  { "code": "dv", "name": "Divehi; Dhivehi; Maldivian" },
  { "code": "dz", "name": "Dzongkha" },
  { "code": "ee", "name": "Ewe" },
  { "code": "el", "name": "Greek, Modern (1453-)" },
  { "code": "en", "name": "English" },
  { "code": "eo", "name": "Esperanto" },
  { "code": "es", "name": "Spanish; Castilian" },
  { "code": "et", "name": "Estonian" },
  { "code": "eu", "name": "Basque" },
  { "code": "fa", "name": "Persian" },
  { "code": "ff", "name": "Fulah" },
  { "code": "fi", "name": "Finnish" },
  { "code": "fj", "name": "Fijian" },
  { "code": "fo", "name": "Faroese" },
  { "code": "fr", "name": "French" },
  { "code": "fy", "name": "Western Frisian" },
  { "code": "ga", "name": "Irish" },
  { "code": "gd", "name": "Gaelic; Scomttish Gaelic" },
  { "code": "gl", "name": "Galician" },
  { "code": "gn", "name": "Guarani" },
  { "code": "gu", "name": "Gujarati" },
  { "code": "gv", "name": "Manx" },
  { "code": "ha", "name": "Hausa" },
  { "code": "he", "name": "Hebrew" },
  { "code": "hi", "name": "Hindi" },
  { "code": "ho", "name": "Hiri Motu" },
  { "code": "hr", "name": "Croatian" },
  { "code": "ht", "name": "Haitian; Haitian Creole" },
  { "code": "hu", "name": "Hungarian" },
  { "code": "hy", "name": "Armenian" },
  { "code": "hz", "name": "Herero" },
  {
    "code": "ia",
    "name": "Interlingua (International Auxiliary Language Association)"
  },
  { "code": "id", "name": "Indonesian" },
  { "code": "ie", "name": "Interlingue; Occidental" },
  { "code": "ig", "name": "Igbo" },
  { "code": "ii", "name": "Sichuan Yi; Nuosu" },
  { "code": "ik", "name": "Inupiaq" },
  { "code": "io", "name": "Ido" },
  { "code": "is", "name": "Icelandic" },
  { "code": "it", "name": "Italian" },
  { "code": "iu", "name": "Inuktitut" },
  { "code": "ja", "name": "Japanese" },
  { "code": "jv", "name": "Javanese" },
  { "code": "ka", "name": "Georgian" },
  { "code": "kg", "name": "Kongo" },
  { "code": "ki", "name": "Kikuyu; Gikuyu" },
  { "code": "kj", "name": "Kuanyama; Kwanyama" },
  { "code": "kk", "name": "Kazakh" },
  { "code": "kl", "name": "Kalaallisut; Greenlandic" },
  { "code": "km", "name": "Central Khmer" },
  { "code": "kn", "name": "Kannada" },
  { "code": "ko", "name": "Korean" },
  { "code": "kr", "name": "Kanuri" },
  { "code": "ks", "name": "Kashmiri" },
  { "code": "ku", "name": "Kurdish" },
  { "code": "kv", "name": "Komi" },
  { "code": "kw", "name": "Cornish" },
  { "code": "ky", "name": "Kirghiz; Kyrgyz" },
  { "code": "la", "name": "Latin" },
  { "code": "lb", "name": "Luxembourgish; Letzeburgesch" },
  { "code": "lg", "name": "Ganda" },
  { "code": "li", "name": "Limburgan; Limburger; Limburgish" },
  { "code": "ln", "name": "Lingala" },
  { "code": "lo", "name": "Lao" },
  { "code": "lt", "name": "Lithuanian" },
  { "code": "lu", "name": "Luba-Katanga" },
  { "code": "lv", "name": "Latvian" },
  { "code": "mg", "name": "Malagasy" },
  { "code": "mh", "name": "Marshallese" },
  { "code": "mi", "name": "Maori" },
  { "code": "mk", "name": "Macedonian" },
  { "code": "ml", "name": "Malayalam" },
  { "code": "mn", "name": "Mongolian" },
  { "code": "mr", "name": "Marathi" },
  { "code": "ms", "name": "Malay" },
  { "code": "mt", "name": "Maltese" },
  { "code": "my", "name": "Burmese" },
  { "code": "na", "name": "Nauru" },
  {
    "code": "nb",
    "name": "Bokmål, Norwegian; Norwegian Bokmål"
  },
  { "code": "nd", "name": "Ndebele, North; North Ndebele" },
  { "code": "ne", "name": "Nepali" },
  { "code": "ng", "name": "Ndonga" },
  { "code": "nl", "name": "Dutch; Flemish" },
  { "code": "nn", "name": "Norwegian Nynorsk; Nynorsk, Norwegian" },
  { "code": "no", "name": "Norwegian" },
  { "code": "nr", "name": "Ndebele, South; South Ndebele" },
  { "code": "nv", "name": "Navajo; Navaho" },
  { "code": "ny", "name": "Chichewa; Chewa; Nyanja" },
  { "code": "oc", "name": "Occitan (post 1500)" },
  { "code": "oj", "name": "Ojibwa" },
  { "code": "om", "name": "Oromo" },
  { "code": "or", "name": "Oriya" },
  { "code": "os", "name": "Ossetian; Ossetic" },
  { "code": "pa", "name": "Panjabi; Punjabi" },
  { "code": "pi", "name": "Pali" },
  { "code": "pl", "name": "Polish" },
  { "code": "ps", "name": "Pushto; Pashto" },
  { "code": "pt", "name": "Portuguese" },
  { "code": "qu", "name": "Quechua" },
  { "code": "rm", "name": "Romansh" },
  { "code": "rn", "name": "Rundi" },
  { "code": "ro", "name": "Romanian; Moldavian; Moldovan" },
  { "code": "ru", "name": "Russian" },
  { "code": "rw", "name": "Kinyarwanda" },
  { "code": "sa", "name": "Sanskrit" },
  { "code": "sc", "name": "Sardinian" },
  { "code": "sd", "name": "Sindhi" },
  { "code": "se", "name": "Northern Sami" },
  { "code": "sg", "name": "Sango" },
  { "code": "si", "name": "Sinhala; Sinhalese" },
  { "code": "sk", "name": "Slovak" },
  { "code": "sl", "name": "Slovenian" },
  { "code": "sm", "name": "Samoan" },
  { "code": "sn", "name": "Shona" },
  { "code": "so", "name": "Somali" },
  { "code": "sq", "name": "Albanian" },
  { "code": "sr", "name": "Serbian" },
  { "code": "ss", "name": "Swati" },
  { "code": "st", "name": "Sotho, Southern" },
  { "code": "su", "name": "Sundanese" },
  { "code": "sv", "name": "Swedish" },
  { "code": "sw", "name": "Swahili" },
  { "code": "ta", "name": "Tamil" },
  { "code": "te", "name": "Telugu" },
  { "code": "tg", "name": "Tajik" },
  { "code": "th", "name": "Thai" },
  { "code": "ti", "name": "Tigrinya" },
  { "code": "tk", "name": "Turkmen" },
  { "code": "tl", "name": "Tagalog" },
  { "code": "tn", "name": "Tswana" },
  { "code": "to", "name": "Tonga (Tonga Islands)" },
  { "code": "tr", "name": "Turkish" },
  { "code": "ts", "name": "Tsonga" },
  { "code": "tt", "name": "Tatar" },
  { "code": "tw", "name": "Twi" },
  { "code": "ty", "name": "Tahitian" },
  { "code": "ug", "name": "Uighur; Uyghur" },
  { "code": "uk", "name": "Ukrainian" },
  { "code": "ur", "name": "Urdu" },
  { "code": "uz", "name": "Uzbek" },
  { "code": "ve", "name": "Venda" },
  { "code": "vi", "name": "Vietnamese" },
  { "code": "vo", "name": "Volapük" },
  { "code": "wa", "name": "Walloon" },
  { "code": "wo", "name": "Wolof" },
  { "code": "xh", "name": "Xhosa" },
  { "code": "yi", "name": "Yiddish" },
  { "code": "yo", "name": "Yoruba" },
  { "code": "za", "name": "Zhuang; Chuang" },
  { "code": "zh", "name": "Chinese" },
  { "code": "zu", "name": "Zulu" }
]

export const EULanguageCodes = ["bg", "cs", "da", "de", "el", "en", "es", "et", "fi", "fr", "ga", "hr", "hu", "it", "lt", "lv", "mt", "nl", "pl", "pt", "ro", "sk", "sl", "sv"]

export const nutritionalCliams = [
  "ADDED ANTIOXIDANTS", "ADDED ARTIFICIAL_SWEETENERS", "ADDED BIOTIN", "ADDED CALCIUM", "ADDED CANE_SUGAR", "ADDED CHOLINE", "ADDED COLOURING_AGENTS", "ADDED COPPER", "ADDED FIBRE", "ADDED FOLIC_ACID", "ADDED FRUIT_JUICE", "ADDED IODINE", "ADDED IRON", "ADDED MAGNESIUM", "ADDED MANGANESE", "ADDED NIACIN", "ADDED OMEGA_3_FATTY_ACIDS", "ADDED PANTOTHENIC_ACID", "ADDED PLANT_STEROLS", "ADDED PRESERVATIVES", "ADDED PROTEIN", "ADDED RIBOFLAVIN", "ADDED SELENIUM", "ADDED SODIUM_SALT", "ADDED SUGARS", "ADDED THIAMIN", "ADDED VITAMINS_AND_OR_MINERALS", "ADDED VITAMIN_A", "ADDED VITAMIN_B12", "ADDED VITAMIN_B6", "ADDED VITAMIN_C", "ADDED VITAMIN_D", "ADDED VITAMIN_E", "ADDED WATER", "ADDED WHEAT", "ADDED WHITE_SUGAR", "ADDED YEAST", "ADDED ZINC", "CONTAINS ", "CONTAINS ADDITIVES", "CONTAINS ALCOHOL", "CONTAINS ALMONDS", "CONTAINS ANTIOXIDANTS", "CONTAINS ARTIFICIAL_COLOUR", "CONTAINS ARTIFICIAL_FLAVOUR", "CONTAINS ARTIFICIAL_SWEETENERS", "CONTAINS ASPARTAME", "CONTAINS AZO_DYE", "CONTAINS BARLEY", "CONTAINS BEEF_GELATINE", "CONTAINS BIOTIN", "CONTAINS CAFFEINE", "CONTAINS CALCIUM", "CONTAINS CANE_SUGAR", "CONTAINS CARRAGEENAN", "CONTAINS CASHEWS", "CONTAINS CHLORIDE", "CONTAINS CHOLINE", "CONTAINS CHROMIUM", "CONTAINS COLOURING_AGENTS", "CONTAINS COPPER", "CONTAINS DAIRY", "CONTAINS DIETARY_FIBRE", "CONTAINS EGGS", "CONTAINS ENERGY", "CONTAINS FAT", "CONTAINS FIBRE", "CONTAINS FISH", "CONTAINS FLAVOUR_ENHANCERS", "CONTAINS FLUORIDE", "CONTAINS FOLIC_ACID", "CONTAINS FRUCTOSE", "CONTAINS FRUIT_JUICE", "CONTAINS GELATINE", "CONTAINS GLUTEN", "CONTAINS GLYZYRRHIZIN", "CONTAINS HAZELNUTS", "CONTAINS HONEY", "CONTAINS IODINE", "CONTAINS IRON", "CONTAINS LACTOSE", "CONTAINS LEGUME_PROTEIN", "CONTAINS LIQUORICE", "CONTAINS MAGNESIUM", "CONTAINS MALT", "CONTAINS MANGANESE", "CONTAINS MILK", "CONTAINS MILK_PROTEIN", "CONTAINS MOLYBDENUM", "CONTAINS MSG", "CONTAINS MULTIGRAIN", "CONTAINS MUSTARD", "CONTAINS NATURALLY_OCCURING_SUGARS", "CONTAINS NATURAL_FLAVOUR", "CONTAINS NIACIN", "CONTAINS NITRATE", "CONTAINS NON_CALORIC_SWEETENERS", "CONTAINS NUTS", "CONTAINS OAT", "CONTAINS OMEGA_3_FATTY_ACIDS", "CONTAINS PALM_OIL", "CONTAINS PANTOTHENIC_ACID", "CONTAINS PEANUTS", "CONTAINS PHENYLALANINE", "CONTAINS PHOSPHATE", "CONTAINS PHOSPHORUS", "CONTAINS PLANT_STEROLS", "CONTAINS POLYUNSATURATED_FAT", "CONTAINS PORK_GELATINE", "CONTAINS POTASSIUM", "CONTAINS PRESERVATIVES", "CONTAINS PROBIOTICS", "CONTAINS PROTEIN", "CONTAINS RIBOFLAVIN", "CONTAINS RYE", "CONTAINS SELENIUM", "CONTAINS SESAME", "CONTAINS SMOKE_FLAVOUR", "CONTAINS SODIUM_NITRITE", "CONTAINS SODIUM_SALT", "CONTAINS SORBITOL", "CONTAINS SOY", "CONTAINS SOYA", "CONTAINS STEVIA", "CONTAINS SUGARS", "CONTAINS SWEETENERS", "CONTAINS THIAMIN", "CONTAINS TREE_NUTS", "CONTAINS VITAMINS_AND_OR_MINERALS", "CONTAINS VITAMIN_A", "CONTAINS VITAMIN_B12", "CONTAINS VITAMIN_B6", "CONTAINS VITAMIN_C", "CONTAINS VITAMIN_D", "CONTAINS VITAMIN_E", "CONTAINS VITAMIN_K", "CONTAINS WATER", "CONTAINS WHEAT", "CONTAINS WHITE_SUGAR", "CONTAINS WHOLE_GRAIN", "CONTAINS WHOLE_WHEAT", "CONTAINS YEAST", "CONTAINS ZINC", "ENRICHED_WITH CALCIUM", "ENRICHED_WITH FOLIC_ACID", "ENRICHED_WITH IODINE", "ENRICHED_WITH IRON", "ENRICHED_WITH LACTOSE", "ENRICHED_WITH NIACIN", "ENRICHED_WITH OMEGA_3_FATTY_ACIDS", "ENRICHED_WITH PLANT_STEROLS", "ENRICHED_WITH RIBOFLAVIN", "ENRICHED_WITH SWEETENERS", "ENRICHED_WITH VITAMINS_AND_OR_MINERALS", "ENRICHED_WITH VITAMIN_B12", "ENRICHED_WITH VITAMIN_D", "ENRICHED_WITH ZINC", "EXCELLENT_SOURCE_OF PROTEIN", "EXTRA_LEAN ENERGY", "FREE_FROM ", "FREE_FROM ADDITIVES", "FREE_FROM ALCOHOL", "FREE_FROM ALMONDS", "FREE_FROM ANTIBIOTICS", "FREE_FROM ARTIFICIAL_COLOUR", "FREE_FROM ARTIFICIAL_FLAVOUR", "FREE_FROM ARTIFICIAL_PRESERVATIVES", "FREE_FROM ARTIFICIAL_SWEETENERS", "FREE_FROM ASPARTAME", "FREE_FROM AZO_DYE", "FREE_FROM BEEF_GELATINE", "FREE_FROM CAFFEINE", "FREE_FROM CALORIE", "FREE_FROM CARRAGEENAN", "FREE_FROM CHOLESTEROL", "FREE_FROM COLOURING_AGENTS", "FREE_FROM CORN", "FREE_FROM CRUSTACEAN", "FREE_FROM DAIRY", "FREE_FROM EGGS", "FREE_FROM ENERGY", "FREE_FROM FAT", "FREE_FROM FISH", "FREE_FROM FLAVOUR_ENHANCERS", "FREE_FROM GELATINE", "FREE_FROM GLUTEN", "FREE_FROM GMO", "FREE_FROM GRAINS", "FREE_FROM HAZELNUTS", "FREE_FROM HONEY", "FREE_FROM IODINE", "FREE_FROM IRON", "FREE_FROM LACTOSE", "FREE_FROM LATEX", "FREE_FROM LIQUORICE", "FREE_FROM MAPLE_SYRUP", "FREE_FROM MEAT", "FREE_FROM MILK", "FREE_FROM MILK_PROTEIN", "FREE_FROM MOLLUSCS", "FREE_FROM MSG", "FREE_FROM MUSTARD", "FREE_FROM NON_CALORIC_SWEETENERS", "FREE_FROM NUTS", "FREE_FROM OAT", "FREE_FROM PALM_OIL", "FREE_FROM PEANUTS", "FREE_FROM PHOSPHATE", "FREE_FROM PINENUTS", "FREE_FROM PORK_GELATINE", "FREE_FROM PRESERVATIVES", "FREE_FROM SESAME", "FREE_FROM SODIUM_NITRITE", "FREE_FROM SODIUM_SALT", "FREE_FROM SOY", "FREE_FROM SOYA", "FREE_FROM SUGARS", "FREE_FROM SWEETENERS", "FREE_FROM TRANS_FAT", "FREE_FROM TREE_NUTS", "FREE_FROM WALNUTS", "FREE_FROM WHEAT", "FREE_FROM WHITE_SUGAR", "FREE_FROM YEAST", "GOOD_SOURCE_OF DIETARY_FIBRE", "GOOD_SOURCE_OF PROTEIN", "GUARANTEED_FREE_FROM ADDITIVES", "GUARANTEED_FREE_FROM EGGS", "GUARANTEED_FREE_FROM GLUTEN", "GUARANTEED_FREE_FROM LACTOSE", "GUARANTEED_FREE_FROM YEAST", "GUARANTEED_SOURCE_OF DIETARY_FIBRE", "GUARANTEED_SOURCE_OF MONO_UNSATURATED_FAT", "GUARANTEED_SOURCE_OF PHENYLALANINE", "GUARANTEED_SOURCE_OF POLYUNSATURATED_FAT", "GUARANTEED_SOURCE_OF PROTEIN", "HEALTHY ", "HIGH ANTIOXIDANTS", "HIGH BIOTIN", "HIGH CAFFEINE", "HIGH CALCIUM", "HIGH CHROMIUM", "HIGH COPPER", "HIGH DIETARY_FIBRE", "HIGH EGGS", "HIGH FIBRE", "HIGH FOLIC_ACID", "HIGH IODINE", "HIGH IRON", "HIGH LEGUME_PROTEIN", "HIGH MAGNESIUM", "HIGH MANGANESE", "HIGH MILK_PROTEIN", "HIGH MONO_UNSATURATED_FAT", "HIGH NIACIN", "HIGH OMEGA_3_FATTY_ACIDS", "HIGH PANTOTHENIC_ACID", "HIGH PHOSPHORUS", "HIGH POLYUNSATURATED_FAT", "HIGH POTASSIUM", "HIGH PROTEIN", "HIGH RIBOFLAVIN", "HIGH SODIUM_SALT", "HIGH SOY", "HIGH SOYA", "HIGH THIAMIN", "HIGH UNSATURATED_FAT", "HIGH VITAMINS_AND_OR_MINERALS", "HIGH VITAMIN_A", "HIGH VITAMIN_B12", "HIGH VITAMIN_B6", "HIGH VITAMIN_C", "HIGH VITAMIN_D", "HIGH VITAMIN_E", "HIGH VITAMIN_K", "HIGH WHOLE_GRAIN", "HIGH ZINC", "HIGH_POTENCY FIBRE", "HIGH_POTENCY PROTEIN", "INCREASED BIOTIN", "INCREASED CALCIUM", "INCREASED COPPER", "INCREASED FOLIC_ACID", "INCREASED IODINE", "INCREASED IRON", "INCREASED MAGNESIUM", "INCREASED MANGANESE", "INCREASED NIACIN", "INCREASED PANTOTHENIC_ACID", "INCREASED RIBOFLAVIN", "INCREASED SELENIUM", "INCREASED THIAMIN", "INCREASED VITAMIN_A", "INCREASED VITAMIN_B12", "INCREASED VITAMIN_B6", "INCREASED VITAMIN_C", "INCREASED VITAMIN_D", "INCREASED VITAMIN_E", "INCREASED ZINC", "LIGHT_LITE ", "LIGHT_LITE CALORIE", "LIGHT_LITE ENERGY", "LIGHT_LITE FAT", "LOW CALORIE", "LOW ENERGY", "LOW FAT", "LOW LACTOSE", "LOW MILK", "LOW MONO_UNSATURATED_FAT", "LOW SATURATED_FAT", "LOW SODIUM_SALT", "LOW SUGARS", "MADE_IN_FACILITY_FREE_FROM LACTOSE", "MADE_WITH SMOKE_FLAVOUR", "MADE_WITH_ORGANIC ", "NATURAL ", "NATURAL LACTOSE", "NATURAL SODIUM_SALT", "NATURAL SUGARS", "NATURAL_SOURCE_OF CAFFEINE", "NATURAL_SOURCE_OF FIBRE", "NATURAL_SOURCE_OF IRON", "NATURAL_SOURCE_OF SODIUM_SALT", "NATURAL_SOURCE_OF SUGARS", "NATURAL_SOURCE_OF VITAMIN_A", "NATURAL_SOURCE_OF VITAMIN_C", "NON_ALCOHOLIC ", "NON_ALCOHOLIC ALCOHOL", "NO_ADDED ADDITIVES", "NO_ADDED ARTIFICIAL_FLAVOUR", "NO_ADDED ARTIFICIAL_PRESERVATIVES", "NO_ADDED ARTIFICIAL_SWEETENERS", "NO_ADDED COLOURING_AGENTS", "NO_ADDED GLUTEN", "NO_ADDED LACTOSE", "NO_ADDED MILK_PROTEIN", "NO_ADDED MSG", "NO_ADDED PHOSPHATE", "NO_ADDED PRESERVATIVES", "NO_ADDED SODIUM_SALT", "NO_ADDED SUGARS", "NO_ADDED SWEETENERS", "NO_ADDED WHEAT", "NO_ADDED WHITE_SUGAR", "NO_ADDED YEAST", "PURE NATURALLY_OCCURING_SUGARS", "PURE NATURAL_FLAVOUR", "PURE OAT", "REDUCED_LESS ENERGY", "REDUCED_LESS FAT", "REDUCED_LESS SODIUM_SALT", "REDUCED_LESS SUGARS", "REDUCED_LESS WHITE_SUGAR", "SOURCE_OF CALCIUM", "SOURCE_OF COPPER", "SOURCE_OF DIETARY_FIBRE", "SOURCE_OF FIBRE", "SOURCE_OF FOLIC_ACID", "SOURCE_OF IODINE", "SOURCE_OF IRON", "SOURCE_OF MAGNESIUM", "SOURCE_OF MONO_UNSATURATED_FAT", "SOURCE_OF NIACIN", "SOURCE_OF OMEGA_3_FATTY_ACIDS", "SOURCE_OF PHENYLALANINE", "SOURCE_OF PHOSPHATE", "SOURCE_OF PHOSPHORUS", "SOURCE_OF POLYUNSATURATED_FAT", "SOURCE_OF POTASSIUM", "SOURCE_OF PROTEIN", "SOURCE_OF RIBOFLAVIN", "SOURCE_OF THIAMIN", "SOURCE_OF UNSATURATED_FAT", "SOURCE_OF VITAMIN_B12", "SOURCE_OF VITAMIN_B6", "SOURCE_OF VITAMIN_C", "SOURCE_OF VITAMIN_D", "SOURCE_OF ZINC", "SWEETENED_WITH ", "SWEETENED_WITH ARTIFICIAL_SWEETENERS", "SWEETENED_WITH FRUCTOSE", "SWEETENED_WITH HONEY", "SWEETENED_WITH NATURAL_FLAVOUR", "SWEETENED_WITH SORBITOL", "SWEETENED_WITH SUGARS", "SWEETENED_WITH SWEETENERS", "UNSWEETENED ", "UNSWEETENED SWEETENERS", "VERY_LOW ALCOHOL", "VERY_LOW CARBOHYDRATES", "VERY_LOW ENERGY", "VERY_LOW GLUTEN", "VERY_LOW LACTOSE", "VERY_LOW MILK_PROTEIN", "VERY_LOW SODIUM_SALT", "VERY_LOW TRANS_FAT"
]

export const nutritionalPerQuantity = [
  "Centilitre (CLT)",
  "Decilitre (DLT)",
  "Gallon (GL)",
  "Gram (GRM)",
  "Piece (H87)",
  "Kilogram (KGM)",
  "Litre (LTR)",
  "Millilitre (MLT)",
  "Percent (P1)",
  "Portion (PTN)",
  "Set (SET)",
]

export const nutritionalCalculatedFor = [
  "PREPARED","UNPREPARED"
]

export const nutritionalQuantityUnit = [
  {value: "Grams Per Cubic Centimetre", code: "23"},
  {value: "Kilocalorie", code: "E14"},
  {value: "Gram", code: "GRM"},
  {value: "Kilojoule", code: "KJO"},
  {value: "Microgram", code: "MC"},
  {value: "Milligram", code: "MGM"},
  {value: "Number of international units", code: "NIU"},
  {value: "Percent", code: "P1"},
  {value: "Retinol Equivalent", code: "XRE"}
]

export const nutritionalPrecision =[
  "ABOUT", "ABSENCE", "APPROXIMATELY", "EXACT", "GREATER_THAN", "GREATER_THAN_OR_EQUAL", "LESS_THAN", "LESS_THAN_OR_EQUAL", "NOT_SIGNIFICANT_SOURCE_OF", "TRACE", "UNSPECIFIED", "USUALLY"
]

export const nutritionalTypeCodes= [
  "ZN","VITK","VITE-","VITD-","VITC-","VITB12","VITB6-","VITA-","THIA","TAU","STARCH","SE","RIBF","PRO-","PANTAC","P","NIA","NA","NACL","MO","MN","MG","LACS","K","ID","GLUCNB","FRUS","FOL","FOLDFE","FIBTG","FE","FD","FAT","FASAT","ENER-","CU","CR","CLD","CHOL-","CHOAVL","CARTB","CAFFN","CA","BIOT","SALTEQ","NUCLEOTIDE","L_CARNITINE","GINSENG","G_NICT","X_FATRSA","POLYL","SUGAR-","FAPUCIS","FAMSCIS","FACN3","FACN6"
]

export const nutritionalNames= [
  {value:"Biotin", code:"BIOT"},
  {value:"Calsium", code:"CA"},
  {value:"Caffeine", code:"CAFFN"},
  {value:"Beta-carotene", code:"CARTB"},
  {value:"Carbohydrate", code:"CHOAVL"},
  {value:"Cholesterol", code:"CHOL-"},
  {value:"Chloride", code:"CLD"},
  {value:"Chromium", code:"CR"},
  {value:"Copper", code:"CU"},
  {value:"Energy", code:"ENER-"},
  {value:"Fatty acids, monounsaturad-cis", code:"FAMSCIS"},
  {value:"Fatty acids, polyunsaturated-cis", code:"FAPUCIS"},
  {value:"Fatty acids, total saturated", code:"FASAT"},
  {value:"Fat", code:"FAT"},
  {value:"Fluoride", code:"FD"},
  {value:"Iron", code:"FE"},
  {value:"Fibre", code:"FIBTG"},
  {value:"Folate", code:"FOL"},
  {value:"Folic acid", code:"FOLDFE"},
  {value:"Fructose", code:"FRUS"},
  {value:"Ginseng", code:"GINSENG"},
  {value:"Betaglucan", code:"GLUCNB"},
  {value:"Nicotine", code:"G_NICT"},
  {value:"Iodide", code:"ID"},
  {value:"Potassium", code:"K"},
  {value:"Lactose", code:"LACS"},
  {value:"Carnitine", code:"L_CARNITINE"},
  {value:"Magnesium", code:"MG"},
  {value:"Manganese", code:"MN"},
  {value:"Molybdenum", code:"MO"},
  {value:"Sodium", code:"NA"},
  {value:"Salt", code:"NACL"},
  {value:"Niacin", code:"NIA"},
  {value:"Beta-hydroxy-beta-methylbutyrate", code:"NUCLEOTIDE"},
  {value:"Phosphorus", code:"P"},
  {value:"Pantothenic acid", code:"PANTAC"},
  {value:"Polyols, total", code:"POLYL"},
  {value:"Protein", code:"PRO-"},
  {value:"Riboflavin", code:"RIBF"},
  {value:"Salt equivalent", code:"SALTEQ"},
  {value:"Selenium", code:"SE"},
  {value:"Starch, total", code:"STARCH"},
  {value:"Sugars, total", code:"SUGAR-"},
  {value:"Taurine", code:"TAU"},
  {value:"Thiamin", code:"THIA"},
  {value:"Vitamin A", code:"VITA-"},
  {value:"Vitamin B-12", code:"VITB12"},
  {value:"Vitamin B-6", code:"VITB6-"},
  {value:"Vitamin C", code:"VITC-"},
  {value:"Vitamin D", code:"VITD-"},
  {value:"Vitamin E", code:"VITE-"},
  {value:"Vitamin K", code:"VITK"},
  {value:"Combined saturated fat and trans fat", code:"X_FATRSA"},
  {value:"Zinc", code:"ZN"},
  {value:"Omega 3 acids", code: "FACN3"},
  {value:"Omega 6 acids", code: "FACN6"},
]

export const restrictionsData=[
  { key: 1, value: "minAge", text: "minAge" }
]

export const doormatModalData=[
  { key: 1, value: "nutrients", text: "Nutritional" }
]

export const certificationsDropdownData =[
  // { key: 1, text: 'MSC', value: 'msc' },
  { key: 2, text: 'UTZ', value: 'utz' },
  { key: 3, text: 'Rainforest Alliance', value: 'rainforestalliance' }
]

export const userLevelOptions =[
  { key: 11, text: 0, value: 0 },
  { key: 1, text: 1, value: 1 },
  { key: 2, text: 2, value: 2 },
  { key: 3, text: 3, value: 3 },
  { key: 4, text: 4, value: 4 },
  { key: 5, text: 5, value: 5 },
  { key: 6, text: 6, value: 6 },
  { key: 7, text: 7, value: 7 },
  { key: 8, text: 8, value: 8 },
  { key: 9, text: 9, value: 9 },
  { key: 10, text: 10, value: 10 },
]

export const userRoleOptions = [
  {key:0, text: 'Not-set', value: 'Not-set'},
  {key:1, text: 'Fish', value: 'Fish'},
  {key:2, text: 'Agri', value: 'Agri'},
  {key:3, text: 'Selfmonitoring', value: 'Selfmonitoring'},

]

export const printJobTypes =[
  {key: 1, text: "Print on Avery 3475 (70 x 36 mm) pre-cut A4", value: 'Avery 3475'},
  // { key: 2, text: "Print 2", value: "Print 2" },
  // { key: 3, text: "Print 3", value: "Print 3" }
]

export const salesStatusData=[
  { key: 1, value: "sell", text: "Sell" },
  { key: 2, value: "presale", text: "Presale" },
  { key: 3, value: "nostock", text: "Nostock" },
  { key: 4, value: "eol", text: "Eol" },
  { key: 5, value: "na", text: "Na" },
  { key: 6, value: "disabled", text: "Disabled" },
]

export const salesDigitalTypeData=[
  { key: 1, value: "postal", text: "Postal" },
  { key: 2, value: "digital", text: "Digital" },
  { key: 3, value: "direct", text: "Direct" },
]



// export const PreparationTypeCode = [
//     {
//         key: 0,
//         text: 'As Drained',
//         value: 'AS_DRAINED',
//     },
//     {
//         key: 1,
//         text: 'Bake',
//         value: 'BAKE',
//     },
//     {
//         key: 2,
//         text: 'Barbecue',
//         value: 'BARBECUE',
//     },
//     {
//         key: 3,
//         text: 'Blanch',
//         value: 'BLANCH',
//     },
//     {
//         key: 4,
//         text: 'Blind Bake',
//         value: 'BLIND_BAKE',
//     },
//     {
//         key: 5,
//         text: 'Boil',
//         value: 'BOIL',
//     },
//     {
//         key: 6,
//         text: 'Braise',
//         value: 'BRAISE',
//     },
//     {
//         key: 7,
//         text: 'Broil',
//         value: 'BROIL',
//     },
//     {
//         key: 8,
//         text: 'Deep Fry',
//         value: 'DEEP_FRY',
//     },
//     {
//         key: 9,
//         text: 'Double Steam',
//         value: 'DOUBLE_STEAM',
//     },
//     {
//         key: 10,
//         text: 'Freeze',
//         value: 'FREEZE',
//     },
//     {
//         key: 11,
//         text: 'Fry',
//         value: 'FRY',
//     },
//     {
//         key: 12,
//         text: 'Griddle Fry',
//         value: 'GRIDDLE_FRY',
//     },
//     {
//         key: 13,
//         text: 'Grill',
//         value: 'GRILL',
//     },
//     {
//         key: 14,
//         text: 'Heat and Serve',
//         value: 'HEAT_AND_SERVE',
//     },
//     {
//         key: 15,
//         text: 'Microwave',
//         value: 'MICROWAVE',
//     },
//     {
//         key: 16,
//         text: 'Pan Fry',
//         value: 'PAN_FRY',
//     },
//     {
//         key: 17,
//         text: 'Poach',
//         value: 'POACH',
//     },
//     {
//         key: 18,
//         text: 'Prepared',
//         value: 'PREPARED',
//     },
//     {
//         key: 19,
//         text: 'Pressure Cook',
//         value: 'PRESSURE_COOK',
//     },
//     {
//         key: 20,
//         text: 'Pressure Fry',
//         value: 'PRESSURE_FRY',
//     },
//     {
//         key: 21,
//         text: 'Ready To Drink',
//         value: 'READY_TO_DRINK',
//     },
//     {
//         key: 22,
//         text: 'Ready To Eat',
//         value: 'READY_TO_EAT',
//     },
//     {
//         key: 23,
//         text: 'Reconstitute',
//         value: 'RECONSTITUTE',
//     },
//     {
//         key: 24,
//         text: 'Refrigerate',
//         value: 'REFRIGERATE',
//     },
//     {
//         key: 25,
//         text: 'Roast',
//         value: 'ROAST',
//     },
//     {
//         key: 26,
//         text: 'Rotisserie',
//         value: 'ROTISSERIE',
//     },
//     {
//         key: 27,
//         text: 'Saute',
//         value: 'SAUTE',
//     },
//     {
//         key: 28,
//         text: 'Sear',
//         value: 'SEAR',
//     },
//     {
//         key: 29,
//         text: 'Simmer',
//         value: 'SIMMER',
//     },
//     {
//         key: 30,
//         text: 'Smoke',
//         value: 'SMOKE',
//     },
//     {
//         key: 31,
//         text: 'Steam',
//         value: 'STEAM',
//     },
//     {
//         key: 32,
//         text: 'Stew',
//         value: 'STEW',
//     },
//     {
//         key: 33,
//         text: 'Stir Fry',
//         value: 'STIR_FRY',
//     },
//     {
//         key: 34,
//         text: 'Thaw',
//         value: 'THAW',
//     },
//     {
//         key: 35,
//         text: 'Unprepared',
//         value: 'UNPREPARED',
//     },
//     {
//         key: 36,
//         text: 'Unknown',
//         value: 'UNSPECIFIED',
//     }
// ]